//@flow
import React from 'react';
import css from './badge.css';

type Props = {
  count: number
}
class Badge extends React.Component < Props > {
  render() {
    return <div className={css.badge}>{this.props.count}</div>
  }
}
export default Badge;